<p-dialog
  [header]="'SDS_ARCHIVE_PICKER_TITLE' | translate"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [style]="{ width: '640px', background: '#fff', overflow: 'hidden' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [baseZIndex]="10000"
  appendTo="body"
  maskStyleClass="sds-archive-picker-mask"
  styleClass="sds-archive-picker-dialog"
>
  <div class="sds-archive-picker">
    <div class="sds-archive-picker-search">
      <i class="pi pi-search"></i>
      <input
        type="text"
        pInputText
        [(ngModel)]="searchTerm"
        [placeholder]="'SDS_ARCHIVE_PICKER_SEARCH' | translate"
      />
    </div>

    <div *ngIf="loading" class="sds-archive-picker-status">
      <i class="pi pi-spin pi-spinner"></i>
      <span [translate]="'SDS_ARCHIVE_PICKER_LOADING'"></span>
    </div>

    <div *ngIf="!loading && error" class="sds-archive-picker-status">
      <span [translate]="'SDS_ARCHIVE_PICKER_ERROR'"></span>
    </div>

    <div *ngIf="!loading && !error && filteredFiles.length === 0" class="sds-archive-picker-status">
      <span [translate]="'SDS_ARCHIVE_PICKER_EMPTY'"></span>
    </div>

    <label *ngIf="multiple && !loading && !error && filteredFiles.length > 0"
      class="sds-archive-picker-select-all">
      <input type="checkbox" [disabled]="selectableFiles.length === 0" [checked]="allVisibleSelected" [indeterminate]="someVisibleSelected"
        (change)="toggleAllVisible()" />
      <span>{{ 'SDS_ARCHIVE_PICKER_SELECT_ALL' | translate }} ({{ selectableFiles.length }})</span>
    </label>

    <ul
      *ngIf="!loading && !error && filteredFiles.length > 0"
      class="sds-archive-picker-list"
    >
      <li *ngFor="let file of filteredFiles" class="sds-archive-picker-item"
        [class.sds-archive-picker-item-added]="addedIds.has(file.id)">
        <input *ngIf="multiple" type="checkbox" [disabled]="addedIds.has(file.id)" [checked]="selectedIds.has(file.id)"
          (change)="toggle(file)" [attr.aria-label]="file.name" />
        <i class="pi pi-file-pdf"></i>
        <div class="sds-archive-picker-item-info">
          <span class="sds-archive-picker-item-name" [title]="file.name">{{ file.name }}</span>
          <span *ngIf="addedIds.has(file.id)" class="sds-archive-picker-added">
            <i class="pi pi-check-circle" aria-hidden="true"></i>
            <span>{{ 'SDS_ARCHIVE_PICKER_ALREADY_ADDED' | translate }}</span>
          </span>
        </div>
        <button
          class="btn btn-outline-secondary btn-sm"
          type="button"
          (click)="preview(file)"
          [pTooltip]="'SDS_ARCHIVE_PICKER_PREVIEW' | translate"
          tooltipPosition="top"
        >
          <i class="pi pi-eye"></i>
        </button>
        <button
          class="btn btn-outline-primary btn-sm"
          type="button"
          *ngIf="!multiple"
          [disabled]="addedIds.has(file.id)"
          (click)="select(file)"
        >
          <span [translate]="'SDS_ARCHIVE_PICKER_SELECT'"></span>
        </button>
      </li>
    </ul>
  </div>
  <ng-template pTemplate="footer">
    <button *ngIf="multiple" class="btn btn-primary" type="button"
      [disabled]="selectedIds.size === 0" (click)="confirmSelection()">
      {{ 'SDS_BULK_ADD_SELECTED' | translate }} ({{ selectedIds.size }})
    </button>
    <button class="btn btn-outline-secondary" type="button" (click)="onVisibleChange(false)">
      <span [translate]="'CLOSE'"></span>
    </button>
  </ng-template>
</p-dialog>

<!-- ═══════════ ARCHIVE PDF PREVIEW ═══════════ -->
<p-dialog
  [header]="previewName || ('SDS_ARCHIVE_PICKER_PREVIEW' | translate)"
  [(visible)]="previewVisible"
  (onHide)="closePreview()"
  [style]="{
    width: '900px',
    height: '85vh',
    maxWidth: '96vw',
    background: '#fff',
    overflow: 'hidden',
    display: 'flex',
    'flex-direction': 'column'
  }"
  [contentStyle]="{
    background: '#fff',
    display: 'flex',
    flex: '1 1 auto',
    'flex-direction': 'column',
    height: 'auto',
    'max-height': 'none',
    'min-height': '0',
    overflow: 'hidden',
    padding: '0'
  }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [baseZIndex]="12000"
  appendTo="body"
  maskStyleClass="sds-archive-preview-mask"
  styleClass="sds-archive-preview-dialog"
>
  <div class="sds-archive-preview-body">
    <div *ngIf="previewLoading" class="sds-archive-picker-status">
      <i class="pi pi-spin pi-spinner"></i>
      <span [translate]="'SDS_ARCHIVE_PICKER_LOADING'"></span>
    </div>
    <iframe
      *ngIf="!previewLoading && previewUrl"
      [src]="previewUrl"
      class="sds-archive-preview-frame"
      title="PDF preview"
    ></iframe>
  </div>
  <ng-template pTemplate="footer">
    <button class="btn btn-outline-secondary" type="button" (click)="closePreview()">
      <span [translate]="'CLOSE'"></span>
    </button>
  </ng-template>
</p-dialog>
